import React, { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import FormTitle from './FormTitle';

interface FormType {
  name: string;
  phoneNumber: string;
  insuranceType: string;
  insuranceName: string;
  hospitalAddress: string;
  accidentType: string;
  insuranceAmount: string;
  description: string;
}

interface CommonFormPropsType {
  form: FormType;
  setForm: Dispatch<SetStateAction<FormType>>;
  label: string;
  placeholder: string;
  textarea?: boolean;
  type: string;
  name: string;
}

const CommonForm = ({ form, setForm, type, label, placeholder, textarea }: CommonFormPropsType) => {
  const updateInputValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (type === 'address') {
      setForm((prev) => ({ ...prev, address: value }));
    } else if (type === 'hospitalAddress') {
      setForm((prev) => ({ ...prev, hospitalAddress: value }));
    } else if (type === 'amount') {
      setForm((prev) => ({ ...prev, insuranceAmount: value }));
    }
  };

  const updateTextareaValue = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    setForm((prev) => ({ ...prev, description: value }));
  };

  return (
    <Wrapper>
      <FormTitle title={label} />
      {textarea ? (
        <StyledTextarea
          rows={10}
          id="place"
          maxLength={300}
          value={form.description}
          onChange={updateTextareaValue}
          placeholder={placeholder}
          required
        />
      ) : (
        <StyledInput
          type="text"
          id="place"
          value={type === 'hospitalAddress' ? form.hospitalAddress : form.insuranceAmount}
          onChange={updateInputValue}
          placeholder={placeholder}
          required
        />
      )}
    </Wrapper>
  );
};

export default CommonForm;

// ======================= styled-components =======================

const Wrapper = styled.div`
  width: 100%;
`;

const StyledTextarea = styled.textarea`
  margin-top: 28px;
  @media (min-width: 640px) {
    margin-top: 22px;
  }

  width: 100%;
  padding: 16px 24px;
  background-color: #f5f5f5; /* bg-gray-100 */
  border-radius: 16px;
  font-weight: bold;
  font-size: 14px;
  line-height: 27px;
  resize: none;
  border: none;
  outline: none;

  &::placeholder {
    font-weight: 300; /* font-light */
    color: #999;
  }

  &:focus {
    border: 1px solid #0b46dd; /* focus:border-blue-200 */
  }
`;

const StyledInput = styled.input`
  margin-top: 26px;
  @media (min-width: 640px) {
    margin-top: 22px;
  }

  width: 100%;
  padding: 27.5px 24px;
  background-color: #f6f7fb; /* bg-gray-100 */
  border-radius: 16px;
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  border: none;
  outline: none;

  @media (min-width: 640px) {
    font-size: 18px;
    line-height: 27px;
  }

  &::placeholder {
    font-weight: 300; /* font-light */
    color: #999;
  }

  &:focus {
    border: 1px solid #0b46dd; /* focus:border-blue-200 */
  }
`;
